export default "__VITE_ASSET__DYsnbgrs__"